import React from 'react'

import * as EmptyState from '@modules/Dashboard/components/EmptyState/EmptyState'
import { useProductsEmptyStateRecommendations } from '@modules/Dashboard/modules/Recommendations'

export const ProductsEmptyStateWithRecommendations = () => {
  const { recommendations } = useProductsEmptyStateRecommendations()

  return (
    <EmptyState.Root
      title="You haven't created any products yet"
      subtitle="Here are a few recommendations to help you get started"
    >
      {recommendations && recommendations.length > 0 && (
        <EmptyState.Recommendations>
          {recommendations.map(({ suggestion, id }) => {
            return (
              <EmptyState.Suggestion key={`recommendation-${id}`} data-analytics={id}>
                {suggestion}
              </EmptyState.Suggestion>
            )
          })}
        </EmptyState.Recommendations>
      )}
    </EmptyState.Root>
  )
}
